import { render, staticRenderFns } from "./peopleList.vue?vue&type=template&id=671fc686&scoped=true&"
import script from "./peopleList.vue?vue&type=script&lang=js&"
export * from "./peopleList.vue?vue&type=script&lang=js&"
import style0 from "./peopleList.vue?vue&type=style&index=0&id=671fc686&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671fc686",
  null
  
)

export default component.exports